export default __webpack_public_path__ + "b0bd48ee9aaa1e4b933cccd5d35be5e5.png";